import "temporal-polyfill/global";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["age", "date"];

  dateTargetConnected(dateTarget) {
    dateTarget.setAttribute("max", this.today.toString());
  }

  update(event = undefined) {
    if (!event.target.value) return;

    const date = Temporal.PlainDate.from(event.target.value);
    const since = this.today.since(date, { smallestUnit: "year" });

    for (const ageTarget of this.ageTargets) {
      ageTarget.value = since.years;
      ageTarget.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  get today() {
    return Temporal.Now.plainDateISO();
  }
}
